export default "__VITE_PUBLIC_ASSET__fa6fab13__"